import React from 'react'
import { Widget } from 'features/types'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'

import { AudienceTrendingWidget as AudienceTrendingWidgetType } from 'schemas/AudienceTrendingWidgetSchema'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { getLabel } from 'utils/widgetTypeUtil'
import { MetricTimeUnit, CountType } from 'enums'
import TrendingWidgetDataGuards from '../share/guards/TrendingWidgetDataGuards'
import Table from '../share/Table'
import InsightModal from '../share/InsightModal'
import useSelectedInsights from '../share/InsightModal/hooks/useSelectedInsights'

const AudienceTrendingWidget: Widget = ({ widgetId }) => {
  const widgetSetting = useDashboardWidgetSetting<AudienceTrendingWidgetType>(widgetId)
  const {
    isModalOpen,
    selectedInsights,
    detailSetting,
    widgetSettingWithSelection,
    onClick,
    onClose
  } = useSelectedInsights(widgetSetting)

  return (
    <UnexpectedErrorBoundary>
      <TrendingWidgetDataGuards widgetId={widgetId}>
        <Table widgetId={widgetId} onRowClick={onClick} />
      </TrendingWidgetDataGuards>
      <InsightModal
        widgetId={widgetId}
        timeUnits={[MetricTimeUnit.ALL]}
        open={isModalOpen}
        onClose={onClose}
        title={widgetSetting?.name || getLabel(widgetSetting?.type)}
        countType={CountType.POSTS}
        selectedInsights={selectedInsights}
        detailSetting={detailSetting}
        widgetSettingWithSelection={widgetSettingWithSelection}
        viewOption={widgetSetting?.viewOption}
      />
    </UnexpectedErrorBoundary>
  )
}

export default AudienceTrendingWidget
